import URL from './url'
import http from '@/utils/httpUtils'

export default {
  // 获取车辆详情
  getVehicleDetail(params) {
    return http.post(URL.API_VEHICLEMANAGE_DETAIL, params)
  },
  // 获取车辆列表
  getVehicleList(params) {
    return http.post(URL.API_VEHICLEMANAGE_LIST, params)
  },
  // 车辆登记
  vehicleRegister(params) {
    return http.post(URL.API_VEHICLEMANAGE_VEHICLE_REGISTER, params)
  },
  // 获取车辆分组
  getVehicelGroup(params) {
    return http.get(URL.API_VEHICLEMANAGE_VEHICLE_GROUP, params)
  },
  // 删除车辆
  deleteVehicle(params) {
    return http.get(URL.API_VEHICLEMANAGE_VEHICLE_DELETE, params)
  },
  // 查询班级下拉框
  getClassList(params) {
    return http.get(URL.API_VEHICLEMANAGE_CLASS_LIST, params)
  },
  // 获取家长关系
  getRelationList(params) {
    return http.get(URL.API_VEHICLEMANAGE_RELATION_LIST, params)
  },
  // 发送消息生成短链接
  sendNotice(params) {
    return http.post(URL.API_VEHICLEMANAGE_COLLECT_NOTICE, params)
  },
  // 查询短链是否过期
  getNotice(params) {
    return http.get(URL.API_VEHICLEMANAGE_COLLECT_EXPIRED, params)
  },
  // 获取车辆列表
  getPageListV2(params) {
    return http.post(URL.API_VEHICLEMANAGE_LIST2, params)
  },
  // 新增车辆
  saveOrUpdateMemberCar(params) {
    return http.post(URL.API_VEHICLEMANAGE_VEHICLE_SAVE, params)
  },
  // 获取车辆详情
  getUserCarV2Detail(params) {
    return http.post(URL.API_VEHICLEMANAGE_DETAIL2, params)
  },
  // 用户车辆删除
  deleteUserCar(params) {
    return http.post(URL.API_VEHICLEMANAGE_VEHICLE_DELETE2, params)
  },
  // 获取全部通行记录
  getAllPageList(params) {
    return http.get(URL.API_VEHICLEMANAGE_ALLLIST, params)
  },
  // 获取我的通行记录
  getOwnerPageList(params) {
    return http.get(URL.API_VEHICLEMANAGE_OWN_LIST, params)
  },
  // 获取学生家长本月停车超时次数
  getTimeoutCount(params) {
    return http.get(URL.API_VEHICLEMANAGE_TIMECOUNT, params)
  },
  // 获取该成员车牌列表
  getLicenseNo(params) {
    return http.get(URL.API_VEHICLEMANAGE_GET_USER_LIENCE_NO, params)
  },
  // 获取指定日期通行记录
  getRecognizeRecordByDimDay(params) {
    return http.get(URL.API_VEHICLEMANAGE_GET_DAT_RECORDS, params)
  },
  // 设置通行规则
  savePassRule(params) {
    return http.post(URL.API_VEHICLEMANAGE_SAVE_PASSRULE, params)
  },
  // 获取通行规则
  getPassRule(params) {
    return http.get(URL.API_VEHICLEMANAGE_GET_PASSRULE, params)
  },
  // 设置超时时间
  saveLimitConfig(params) {
    return http.post(URL.API_VEHICLEMANAGE_SAVE_LIMIT_CONFIG, params)
  },
  // 获取超时时间
  getLimitConfig(params) {
    return http.get(URL.API_VEHICLEMANAGE_GET_LIMIT_CONFIG, params)
  },
  // 保存自动拉黑相关配置
  saveBlackConfig(params) {
    return http.post(URL.API_VEHICLEMANAGE_SAVE_BLACK_CONFIG, params)
  },
  // 添加黑名单
  addBlackMember(params) {
    return http.post(URL.API_VEHICLEMANAGE_ADD_BLACK, params)
  },
  // 删除黑名单
  deleteBlackMember(params) {
    return http.post(URL.API_VEHICLEMANAGE_DELETE_BLACK, params)
  },
  // 查询黑名单列表
  getBlacklist(params) {
    return http.get(URL.API_VEHICLEMANAGE_GET_BLACK_LIST, params)
  },
  // 保存超时通知配置
  saveTimeoutNoticeConfig(params) {
    return http.post(URL.API_VEHICLEMANAGE_SAVE_TIME_CONFIG, params)
  },
  // 保存超时拉黑提醒通知配置
  saveBlacklistNoticeConfig(params) {
    return http.post(URL.API_VEHICLEMANAGE_SAVE_BLACK_NOTICE_CONFIG, params)
  },
  // 获取当前校区空闲车位数量
  getFreeParkingSpaceCount(params) {
    return http.get(URL.API_VEHICLEMANAGE_GET_LEFT_COUNT, params)
  },
  // 获取当前校区车闸版本
  getBarrierGateVersion(params) {
    return http.get(URL.API_VEHICLE_GET_PARKING_INFO, params)
  },
  // 绑定车场
  setParkingInfo(params) {
    return http.post(URL.API_VEHICLE_BIND_PARKING_INFO, params)
  },
  // 解绑车场
  unbindParkingInfo(params) {
    return http.post(URL.API_VEHICLE_UNBIND_PARKING_INFO, params)
  },
  getVehicelSetting(params) {
    return http.get(URL.API_VEHIDCLE_SETTING, params)
  },
  getUserCalendarState(params) {
    return http.get(URL.API_VEHICLE_CALENDAR_STATE, params)
  },
  getCalendarUserInfo(params) {
    return http.get(URL.API_VEHICLE_CALENDAR_USER_INFO, params)
  },
  // 消息通知，通过paramId获取url参数
  getUrlByParamId(params) {
    return http.get(URL.API_GET_URL_BY_PARAMID, params)
  },
  // 一键抬杆
  controlBarrierDevice(params) {
    return http.post(URL.API_VEHICLE_CAR_BARRIER_CONTROL, params)
  },
  // 获取车闸设备列表
  getThirdCarDeviceList(params) {
    return http.post(URL.API_VEHICLE_CAR_BARRIER_LIST, params)
  },
  // 车辆通行申请
  barrierGateAccessApply(params) {
    return http.post(URL.API_VEHICLE_CAR_BARRIER_ACCESS_APPLY, params)
  },
  // 车辆通行审批
  barrierGateAccessAudit(params) {
    return http.post(URL.API_VEHICLE_CAR_BARRIER_ACCESS_AUDIT, params)
  },
  // 车辆通行审批列表
  barrierGateAccessList(params) {
    return http.get(URL.API_VEHICLE_CAR_BARRIER_ACCESS_LIST, params)
  }
}
